export const lockFocusToModal = (
  containerElement,
  onClose,
  focusFirstElement = false
) => {
  if (!containerElement) return;
  const focusableElements = Array.from(
    containerElement?.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
  ).filter(
    (el) =>
      !el.hasAttribute('disabled') &&
      el.offsetParent !== null &&
      el.offsetParent !== undefined
  );
  if (!focusableElements) return; // To prevent error when focusableElements is null
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];
  const prevActiveElement = document.activeElement;

  if (focusFirstElement && firstElement) {
    firstElement.focus();
  }

  const handleTabKeyPress = (event) => {
    if (event.key === 'Tab') {
      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }
    if (event.key === 'Escape' && onClose) {
      onClose();
      prevActiveElement.focus();
    }
  };

  containerElement?.addEventListener('keydown', handleTabKeyPress);
  return () => {
    containerElement?.removeEventListener('keydown', handleTabKeyPress);
  };
};

export const GetSearchUrl = (q) => {
  const queryParams = q && q.length > 0 ? `?q=${q}` : '';
  return window.__litium.quickSearchUrl + queryParams;
};

//Colors used in js
export const colors = {
  apex: {
    infoBoxBorder: '#5F5F60',
  },
  bendix: {
    infoBoxBorder: '#6E7072',
  },
};

// Builds the "postal code / city" locality line for an address.
// Danish (DK) addresses show the postal code before the city — e.g. "6451 Groninge" —
// while all other countries keep their existing "city zip" order. The separator is only
// used for the non-Danish order (some call sites separate city and zip with a comma).
export const formatLocality = (city, zipCode, country, separator = ' ') => {
  const normalizedCountry = String(country || '').trim().toUpperCase();
  const isDanish =
    normalizedCountry === 'DK' ||
    normalizedCountry === 'DENMARK' ||
    normalizedCountry === 'DANMARK';
  const parts = isDanish ? [zipCode, city] : [city, zipCode];
  return parts.filter(Boolean).join(isDanish ? ' ' : separator);
};

export const formatDate = (date) => {
  try {
    const updatedDate = new Date(date);
    const [year, month, day] = updatedDate
      .toISOString()
      .split('T')[0]
      .split('-');
    const isBendix =
      typeof window !== 'undefined' &&
      window.__litium?.currentTheme?.toLowerCase() === 'bendix';
    const separator = isBendix ? '/' : '-';
    return `${day}${separator}${month}${separator}${year}`;
  } catch {
    return date;
  }
};
